// extracted by mini-css-extract-plugin
module.exports = {"contact":"Contact_contact__Qc5tX"};